import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (!hash) {
            window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
        }
    }, [pathname, hash]);
    return null;
};

export default ScrollToTop;
